import {
    // eslint-disable-next-line no-restricted-imports
    Link,
    LinkProps,
    forwardRef,
} from "@chakra-ui/react";

export interface IWfLinkProps extends LinkProps {
    href: string;
}

export interface IWfLinkVariantProps extends Omit<IWfLinkProps, "variant"> {}
/**
 * @deprecated Use MUI Link component instead.
 */
export const WfLink = forwardRef<IWfLinkProps, "a">(({ children, href, ...linkProps }, ref) => {
    return (
        <Link ref={ref} href={href} {...linkProps}>
            {children}
        </Link>
    );
});

/**
 * @deprecated Use MUI Link component instead.
 */
export const WfLinkUnstyled = forwardRef<IWfLinkVariantProps, "a">(({ children, href, ...linkProps }, ref) => {
    return (
        <Link ref={ref} href={href} {...linkProps} variant="unstyled">
            {children}
        </Link>
    );
});

/**
 * @deprecated Use MUI Link component instead.
 * Example:
 * <Link
 *   underline="hover"
 * >
 *   {children}
 * </Link>
 */
export const WfLinkGhost = forwardRef<IWfLinkVariantProps, "a">(({ children, href, ...linkProps }, ref) => {
    return (
        <Link ref={ref} href={href} {...linkProps} variant="ghost">
            {children}
        </Link>
    );
});
